module.exports = __webpack_public_path__ + "static/img/2.ecdc561.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p1/2.png
// module id = eEBV
// module chunks = 1